(function () {
    'use strict';

    angular
        .module('app')
        .controller('SendReportDialogCtrl', SendReportDialogCtrl);

    SendReportDialogCtrl.$inject = ['DialogInstance', 'reportType', 'sendReports'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for showing a send report
     *
     * @param {string} reportType - Email or SMS
     * @param {array} sendReports
     */
    function SendReportDialogCtrl(DialogInstance, reportType, sendReports) {
        /* jshint validthis:true */
        var vm = this;

        vm.reportType = reportType;
        vm.sendReports = sendReports;

        vm.title = 'Sent ' + vm.reportType + ' Report';
        vm.toggleDetails = toggleDetails;
        vm.getRecipientDetails = getRecipientDetails;
        vm.getReportLink = getReportLink;
        vm.getReportLinkIcon = getReportLinkIcon;
        vm.close = close;
        Object.defineProperty(vm, 'entityTemplateName', {
            get: function () {
                var fromEntity = _.find(sendReports, function (sendReport) { return !_.isNil(sendReport.FromEntityTemplateName) && sendReport.FromEntityTemplateName !== ''; });
                if (!_.isNil(fromEntity)) {
                    return fromEntity.FromEntityTemplateName;
                } else {
                    return 'Name';
                }
            }
        });


        /**
         * Toggles the ShowDetails property of the supplied object
         */
        function toggleDetails(report) {
            if (report.ShowDetails) {
                report.ShowDetails = false;
            } else {
                report.ShowDetails = true;
            }
        }

        /**
         * Gets the recipient information in a user readable format using the supplied recipient information.
         *
         * @returns {string} Returns user readable recipient information.
         */
        function getRecipientDetails(recipient) {
            var result = '';

            if (!_.isNil(recipient)) {
                var recipientContactValue = '';

                if (reportType === 'Email') {
                    recipientContactValue = recipient.Contact.Value;

                    if (!_.isNil(recipient.Type) && recipient.Type !== '') {
                        result += recipient.Type + ": ";
                    }

                    if (!_.isNil(recipient.Contact.Name) && recipient.Contact.Name !== '') {
                        result += recipient.Contact.Name + ' <' + recipientContactValue + '>';
                    } else {
                        result += recipientContactValue;
                    }

                } else {
                    recipientContactValue = recipient.Value;

                    if (!_.isNil(recipient.Name) && recipient.Name !== '') {
                        result += recipient.Name + ' <' + recipientContactValue + '>';
                    } else {
                        result += recipientContactValue;
                    }
                }
            }

            return result;
        }

        /**
         * Gets the link for the item being reported. (e.g. SMS, Email)
         *
         * @returns {string} Returns user readable recipient information.
         */
        function getReportLink(sendReport) {
            var result;

            switch (reportType) {
                case 'Email':
                    if (!_.isNil(sendReport.EmailLink) && sendReport.EmailLink !== '') {
                        result = '#/email/' + sendReport.EmailLink;
                    }
                    break;
                case 'SMS':
                    if (!_.isNil(sendReport.SMSLink) && sendReport.SMSLink !== '') {
                        result = '#/sms/' + sendReport.SMSLink;
                    }
                    break;
            }

            return result;
        }

        /**
         * Gets the icon usage for the item being reported. (e.g. SMS, Email)
         *
         * @returns {string} Usage for the report.
         */
        function getReportLinkIcon() {
            var result = '';

            switch (reportType) {
                case 'Email':
                    result = 'email';
                    break;
                case 'SMS':
                    result = 'sms';
                    break;
            }

            return result;
        }

        function close() {
            DialogInstance.ok();
        }
    }
})();
